'use client'

import { useEffect } from 'react'
import { useSession } from '@/contexts/session-context'

/**
 * Publica `user_id` e `login_status` no dataLayer a partir da sessão que já
 * está em memória (SessionProvider), sem nenhuma requisição extra. As chaves
 * ficam no data model do GTM e acompanham todos os eventos seguintes.
 *
 * `user_id` usa o `reference` do usuário (identificador interno e opaco), nunca
 * e-mail ou CPF. Quando não há sessão envia `null` para limpar o valor
 * anterior após um logout em navegação SPA.
 */
export function UserContextEvent() {
  const { isLoaded, isSignedIn, user } = useSession()
  const userId = isSignedIn ? (user?.reference ?? null) : null

  useEffect(() => {
    if (!isLoaded) {
      return
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      user_id: userId,
      login_status: isSignedIn ? 'logged_in' : 'guest',
    })
  }, [isLoaded, isSignedIn, userId])

  return null
}
